import { apiSlice } from "./apiSlice";

export const stripeApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // createContactUs: builder.mutation({
    //   query: (contactUsData) => ({
    //     url: "/contactUs/createContactUs",
    //     method: "POST",
    //     body: contactUsData,
    //   }),
    // }),

    getSubscription: builder.query({
      query: () => ({
        url: "/stripe/getSubscription",
        method: "GET",
      }),
    }),
  }),
});

export const { useGetSubscriptionQuery } = stripeApi;
